import {
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { DataStore } from '@compiere-ws/models/compiere-data-json';
import { POTable } from '@compiere-ws/models/po.models';
import { PoService } from '@compiere-ws/services/po/po.service';
import { EditViewUiComponent } from '@iupics-components/standard/layouts/edit-view-ui/edit-view-ui.component';
import { DataStoreService } from '@iupics-manager/managers/data-store/data-store.service';
import { MessageManagerService } from '@iupics-manager/managers/message/message-manager.service';
import { SecurityManagerService } from '@iupics-manager/managers/security-manager/security-manager.service';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { AbstractDataContainer } from '@iupics-manager/models/abstract-datacontainer';
import { DynamicComponent } from '@iupics-manager/models/dynamic-component';
import { Global } from '@iupics-manager/models/global-var';
import { IupicsEvent, IupicsTypeEvent } from '@iupics-manager/models/iupics-event';
import { IupicsMessage } from '@iupics-manager/models/iupics-message';
import { ContextMenuService } from '@web-desktop/components/workspace/controllers/context-menu/context-menu.service';

@Component({
  selector: 'iu-button-ui',
  templateUrl: './button-ui.component.html',
  styleUrls: ['./button-ui.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ButtonUiComponent extends AbstractDataContainer implements OnInit, OnDestroy {
  @ViewChild('btn', { read: ElementRef, static: true }) btnElt: ElementRef<HTMLButtonElement>;
  @Input() icon = '';
  @Input() type: 'primary' | 'p-button-secondary' | 'info' | 'warning' | 'alert' | '' = '';
  private listener: Function;

  itemData: DynamicComponent;

  private tableName: string;
  private isSOTrx: boolean;
  @Input()
  channelId;
  @Input()
  columnName: string;

  @HostBinding('class.is-field') isFieldClass = false;

  constructor(
    public elementRef: ElementRef,
    public store: DataStoreService,
    protected connectorService: SecurityManagerService,
    public cmService: ContextMenuService,
    public uiCreatorService: UICreatorService,
    protected renderer: Renderer2,
    protected po: PoService,
    protected messageManager: MessageManagerService
  ) {
    super(elementRef, connectorService, cmService, store, uiCreatorService, renderer, po);
  }

  ngOnInit() {
    super.ngOnInit();
    this.cssGrid = this.cssClass;
    if (this.fieldValue instanceof Object && this.fieldValue.displayValue) {
      this.label = this.fieldValue.displayValue;
    }
    // Ajout des events sur le bouton
    if (this.itemData) {
      let parent: any = <EditViewUiComponent>(
        this.container.DOMChildrenComponent.find(
          (DOMChild: any) => DOMChild instanceof EditViewUiComponent && DOMChild.tabId === this.data.tabId
        )
      );
      parent = parent ? parent : this.editViewParent ? this.editViewParent : this.container;
      if (this.itemData.processId) {
        this.data['processId'] = this.itemData.processId;
        this.listener = this.renderer.listen(this.btnElt.nativeElement, 'click', ($event: MouseEvent) => {
          $event.stopPropagation();
          parent.updateModalDisplay(
            { key: 'displayProcessUI', value: true, sourceComponent: this },
            { key: 'processId', value: this.data['processId'] }
          );
        });
      } else if (this.itemData.formId) {
        //TODO à commenter si on ne veut pas charger les données d'une form pour affichage instantanné au clic.
        if (!Global.isMobile()) {
          this.subscriptions.push(this.uiCreatorService.getSpecificWindow(this.itemData.formId).subscribe());
        }
        this.data['formId'] = this.itemData.formId;
        this.listener = this.renderer.listen(this.btnElt.nativeElement, 'click', ($event: MouseEvent) => {
          $event.stopPropagation();
          parent.updateModalDisplay(
            { key: 'displayFormUI', value: true, sourceComponent: this },
            { key: 'formId', value: this.data['formId'] }
          );
        });
      }
    }
    this.isFieldClass = this.editViewParent ? true : false;
  }
  onChildUpdate(event: IupicsEvent) {}
  onSiblingUpdate(event: IupicsEvent) {}
  onRemoveComponent(event: IupicsEvent) {}

  private initZoom() {
    if (this.dataStored.data.AD_Table_ID !== undefined && this.dataStored.data.AD_Table_ID !== null) {
      this.subscriptions.push(
        this.po.get<POTable>('AD_Table', this.dataStored.data.AD_Table_ID.id).subscribe((table) => {
          this.tableName = table.TableName;
          if (this.dataStored.data.IsSOTrx !== undefined) {
            this.isSOTrx = this.dataStored.data.IsSOTrx === 'Y';
          } else {
            this.isSOTrx = undefined;
          }
          if (this.listener !== undefined) {
            this.listener();
            this.listener = undefined;
          }

          this.listener = this.renderer.listen(this.btnElt.nativeElement, 'click', ($event: MouseEvent) => {
            $event.stopPropagation();
            this.subscriptions.push(
              this.uiCreatorService
                .zoomAcross(this.tableName, this.tableName + '_ID', this.dataStored.data.Record_ID, this.isSOTrx)
                .subscribe(
                  (dataWs) => {
                    if (dataWs && dataWs.length > 0) {
                      this.zoomInfo = {
                        windowId: dataWs[0].Window_ID,
                        dataUUID: dataWs[dataWs.length - 1]['Record_ID'],
                        record_id: this.dataStored.data.Record_ID,
                        children: dataWs.length > 1 ? dataWs.splice(0, dataWs.length - 1) : null
                      };
                      if (this.data.IsParam) {
                        this.isZoom = false;
                        Global.workspace.openTargetSearch({
                          zoomInfo: this.zoomInfo,
                          cat: { id: parseInt(dataWs[0].Window_ID, 10) },
                          source: { id: this.dataStored.data.Record_ID !== -1 ? dataWs[0].Record_ID : 'newRecord' }
                        });
                      } else {
                        this.subscriptions.push(
                          this.uiCreatorService
                            .getWindow(parseInt(dataWs[dataWs.length - 1]['Window_ID'], 10))
                            .subscribe((tabs) => {
                              const item: DynamicComponent = {
                                container: this.container,
                                DOMParentComponent: this.container,
                                linkedComponents: [this],
                                component: 'EditViewUiComponent',
                                cssClass: 'iupics-blade-content',
                                isCssOnComponent: false,
                                tabId: tabs[0].tabId,
                                zoomInfo: this.zoomInfo
                              };
                              this.componentEmitter.emit({
                                type: IupicsTypeEvent.showEditView,
                                item: item
                              });
                            })
                        );
                      }
                    }
                  },
                  (err) => {
                    this.isZoom = false;
                  }
                )
            );
          });
        })
      );
    } else {
      this.listener = this.renderer.listen(this.btnElt.nativeElement, 'click', ($event: MouseEvent) => {
        this.messageManager.newMessage(new IupicsMessage('Error', 'No record id linked'));
      });
    }
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.listener !== undefined) {
      this.listener();
    }
  }

  changeFieldValue(dataStored: DataStore, fromOtherChange: boolean = false, calloutStack: string[] = []) {
    super.changeFieldValue(dataStored, fromOtherChange, calloutStack);

    if (this.fieldValue instanceof Object && this.fieldValue.displayValue) {
      this.label = this.fieldValue.displayValue;
    }
    if (this.data.columnName === 'Record_ID') {
      this.initZoom();
    }
  }
}
